<template>
  <ul class="form__Errors" v-if="errors?.length">
    <li
      :class="['form__Error', className]"
      v-for="e in Array.isArray(errors) ? errors : [errors]"
      v-text="errorsMapper?.[e?.code] || e" />
  </ul>
</template>

<script setup>
  const { t } = useI18n();
  defineProps({
    errors: {
      type: [Array, String, Object]
    },
    className: {
      type: String
    }
  })

  const errorsMapper = {
    required: t('formErrors.required'),
    PREFERREDLANGUAGE_REQUIRED: t('formErrors.required'),
    ADDRESS_REQUIRED: t('formErrors.required'),
    CITY_REQUIRED: t('formErrors.required'),
    COUNTRYCODE_REQUIRED: t('formErrors.required'),
    FIRST_NAME_REQUIRED: t('formErrors.required'),
    LAST_NAME_REQUIRED: t('formErrors.required'),
    EMAIL_REQUIRED: t('formErrors.required'),
    PASSWORD_REQUIRED: t('formErrors.required'),
    CONFIRM_PASSWORD_REQUIRED: t('formErrors.required'),
    INVALID_EMAIL_FORMAT: t('formErrors.email'),
    invalid: t('formErrors.invalid'),
    invalid_choice: t('formErrors.invalid'),
    blank: t('formErrors.blank'),
    null: t('formErrors.null'),
    max_length: t('formErrors.maxLengthWithoutValue'),
    max_value: t('formErrors.maxValue'),
    min_value: t('formErrors.minValue'),
    invalid_year: t('formErrors.invalidYear'),
    user_exists: t('formErrors.userExists'),
    no_active_account: t('formErrors.no_active_account'),
    activation_token_invalid: t('loyaltyErrors.activationTokenInvalid'),
    100: t('loyaltyErrors.error100'),
    101: t('loyaltyErrors.error101'),
    102: t('loyaltyErrors.error102'),
    103: t('loyaltyErrors.error103'),
    104: t('loyaltyErrors.error104'),
    105: t('loyaltyErrors.error105'),
    106: t('loyaltyErrors.error106'),
    107: t('loyaltyErrors.error107'),
    108: t('loyaltyErrors.error108'),
    109: t('loyaltyErrors.error109'),
    110: t('loyaltyErrors.error110'),
    111: t('loyaltyErrors.error111'),
    112: t('loyaltyErrors.error112'),
  };
</script>
